import styled from "styled-components";
import { GrayColors } from "@smartsuite/types";

export const RecordsNoOptions = styled.div`
  display: flex;
  padding: 9px 15px;
  background: ${GrayColors["G-0-5"]};
  border-radius: 8px;
`;

export const RecordsNoOptionsIcon = styled.div`
  display: flex;
  align-items: center;
  margin-right: 15px;
`;
export const RecordsNoOptionsInner = styled.div`
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
`;
